import React, { useState } from "react";
import { Menu, LayoutDashboard, GraduationCap, LogOut, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const BrandLogo = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 30 L18 16 L18 24 L30 24 L30 16 L44 30 L44 34 L4 34 Z" fill="#63c26a" />
    <rect x="14" y="30" width="20" height="8" rx="2" fill="#ffffff" />
    <circle cx="18" cy="40" r="3.4" fill="#0a2447" />
    <circle cx="30" cy="40" r="3.4" fill="#0a2447" />
  </svg>
);

const initials = (name) => (name || "?").trim().split(/\s+/).map((n) => n[0]).slice(0, 2).join("").toUpperCase();

const AccountMenu = ({ user, logout, onNav }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="acct-menu" data-testid="account-menu">
      <button className="acct-trigger" onClick={() => setOpen((v) => !v)} data-testid="account-trigger">
        {user.picture ? <img src={user.picture} alt="" className="acct-avatar-img" referrerPolicy="no-referrer" /> : <span className="acct-avatar">{initials(user.name)}</span>}
        <span className="acct-name">{(user.name || "").split(" ")[0] || "Account"}</span>
        <ChevronDown size={15} className={open ? "rot" : ""} />
      </button>
      {open && (
        <div className="acct-dropdown" data-testid="account-dropdown">
          <div className="acct-head">
            {user.picture ? <img src={user.picture} alt="" className="acct-avatar-img lg" referrerPolicy="no-referrer" /> : <span className="acct-avatar lg">{initials(user.name)}</span>}
            <div><span className="acct-dd-name">{user.name}</span><span className="acct-dd-email">{user.email}</span></div>
          </div>
          <Link to="/training" className="acct-item" onClick={() => { setOpen(false); onNav && onNav(); }} data-testid="account-my-course"><GraduationCap size={15} /> My Course</Link>
          <Link to={user.role === "admin" ? "/admin" : "/portal"} className="acct-item" onClick={() => { setOpen(false); onNav && onNav(); }}><LayoutDashboard size={15} /> {user.role === "admin" ? "Admin Dashboard" : "My Portal"}</Link>
          <button className="acct-item danger" onClick={() => { logout(); setOpen(false); onNav && onNav(); }} data-testid="account-logout"><LogOut size={15} /> Log out</button>
        </div>
      )}
    </div>
  );
};

const Header = () => {
  const [open, setOpen] = useState(false);
  const { user, logout, loading } = useAuth();

  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="container nav">
        <a href="#top" className="brand" onClick={close}>
          <BrandLogo />
          <span className="brand-text">
            <span className="top">FLYING FLEET</span>
            <br />
            <span className="bottom">DISPATCH LLC</span>
          </span>
        </a>
        <ul className={`nav-links ${open ? "open" : ""}`}>
          <li><a href="#services" onClick={close}>Services</a></li>
          <li><a href="#loadboard" onClick={close}>Load Board</a></li>
          <li><a href="#reviews" onClick={close}>Reviews</a></li>
          <li><a href="#testimonials" onClick={close}>Testimonials</a></li>
          <li><a href="#web-design" onClick={close}>Web Design</a></li>
          <li><Link to="/training" onClick={close}>Training</Link></li>
          <li><Link to="/games" onClick={close}>Games</Link></li>
          <li><a href="#careers" onClick={close}>Careers</a></li>
          <li><a href="#brokers" onClick={close}>Brokers</a></li>
          <li><a href="#fmcsa" onClick={close}>Filing</a></li>
          <li><a href="#about" onClick={close}>About</a></li>
          {loading ? null : user ? (
            <li className="nav-acct"><AccountMenu user={user} logout={logout} onNav={close} /></li>
          ) : (
            <li><Link to="/training" className="nav-portal" onClick={close}>Sign In</Link></li>
          )}
          <li><a href="#contact" className="nav-cta" onClick={close}>Get Dispatched</a></li>
        </ul>
        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <Menu />
        </button>
      </div>
    </header>
  );
};

export default Header;
